<div class="row">
  <div class="col-12">
    <p class="no-matches rounded p-3">
      <ucs-icon [class]="'blue'" [shape]="'info'" [size]="24"></ucs-icon>
      <span class="text ms-2">{{ translationKey | translate }}</span>
    </p>
  </div>
</div>
